(function () {

  var wrapper =
    document.getElementById('obd-product-compare');

  if (!wrapper) return;

  var productTitle =
    wrapper.getAttribute('data-product-title') || '';

  var productHandle =
    wrapper.getAttribute('data-product-handle') || '';

  var button =
    document.getElementById('obd-compare-button');

  var description =
    document.getElementById('obd-compare-description');

  if (!button) return;


  /*
   * =========================================================
   * REMOVE "SECONDS AGO" / "MINUTES AGO"
   * =========================================================
   */

  function isRelativeTimeText(text) {

    var value =
      String(text || '')
        .trim()
        .toLowerCase();

    if (!value) return false;

    return (
      /^\d+\s*seconds?\s+ago$/.test(value) ||
      /^\d+\s*minutes?\s+ago$/.test(value) ||
      /^\d+\s*hours?\s+ago$/.test(value) ||
      /^a\s+few\s+seconds\s+ago$/.test(value) ||
      /^just\s+now$/.test(value)
    );

  }


  function removeInjectedTimeText() {

    Array.from(
      wrapper.childNodes
    ).forEach(function (node) {

      /*
       * Only remove direct text nodes.
       *
       * This will NOT remove:
       *
       * Not sure which Autel scanner to choose?
       * Compare MK900-BT with similar...
       * Compare MK900-BT →
       */

      if (
        node.nodeType === Node.TEXT_NODE &&
        isRelativeTimeText(node.textContent)
      ) {

        node.remove();

      }

    });

  }


  /*
   * Remove existing text immediately.
   */

  removeInjectedTimeText();


  /*
   * Some Shopify themes / apps insert or update
   * the relative-time text AFTER page load.
   *
   * Observe only this Compare wrapper.
   */

  var timeObserver =
    new MutationObserver(function () {

      removeInjectedTimeText();

    });


  timeObserver.observe(
    wrapper,
    {
      childList: true,
      characterData: true,
      subtree: false
    }
  );


  /*
   * Extra delayed checks for scripts that run later.
   */

  window.setTimeout(
    removeInjectedTimeText,
    300
  );

  window.setTimeout(
    removeInjectedTimeText,
    1000
  );

  window.setTimeout(
    removeInjectedTimeText,
    3000
  );


  /*
   * =========================================================
   * SUPPORTED COMPARE MODELS
   * =========================================================
   */

  var supportedModels = [

    'MK906S Pro2-TS',
    'MS908S Pro II',
    'MS906 Pro-TS',
    'MP808BT Pro',
    'MK808BT Pro',
    'Elite II Pro',
    'Ultra Lite S',
    'MK906S Pro',
    'MK900-TS',
    'MK900-BT',
    'MX808S-TS',
    'MX900-TS',
    'MP900-TS',
    'MP900-BT',
    'MS906 Pro',
    'Ultra S2',
    'MX808S',
    'MK808Z',
    'MP808S',
    'MX900',
    'MP900',
    'MK908 II',
    'MS909',
    'MS919',
    'Ultra'

  ];


  /*
   * =========================================================
   * MODEL ALIASES
   * =========================================================
   */

  var aliases = [

    {
      compareModel: 'MK906S Pro2-TS',

      names: [
        'MK906S PRO2-TS',
        'MK906S PRO 2-TS',
        'MK906S PRO II TS',
        'MK906S PRO II-TS'
      ]
    },

    {
      compareModel: 'MS908S Pro II',

      names: [
        'MS908S PRO II',
        'MS908S PRO 2',
        'MS908S PROII'
      ]
    },

    {
      compareModel: 'MK908 II',

      names: [
        'MK908 II',
        'MK908 2',
        'MK908II'
      ]
    },

    {
      compareModel: 'Elite II Pro',

      names: [
        'ELITE II PRO',
        'ELITE 2 PRO',
        'ELITE IIPRO'
      ]
    },

    {
      compareModel: 'Ultra Lite S',

      names: [
        'ULTRA LITE S',
        'ULTRALITE S',
        'ULTRA LITES'
      ]
    },

    {
      compareModel: 'Ultra S2',

      names: [
        'ULTRA S2',
        'ULTRAS2'
      ]
    }

  ];


  /*
   * =========================================================
   * NORMALIZE
   * =========================================================
   */

  function normalize(value) {

    return String(value || '')

      .toUpperCase()

      .replace(/™/g, '')

      .replace(/®/g, '')

      .replace(/[–—]/g, '-')

      .replace(/\s+/g, ' ')

      .trim();

  }


  function compact(value) {

    return normalize(value)

      .replace(/[\s\-]+/g, '');

  }


  /*
   * =========================================================
   * DETECT MODEL
   * =========================================================
   */

  function detectModel(title) {

    var normalizedTitle =
      normalize(title);


    /*
     * Aliases first.
     */

    for (
      var a = 0;
      a < aliases.length;
      a++
    ) {

      var aliasGroup =
        aliases[a];


      for (
        var n = 0;
        n < aliasGroup.names.length;
        n++
      ) {

        if (

          compact(normalizedTitle)

            .indexOf(

              compact(
                aliasGroup.names[n]
              )

            ) !== -1

        ) {

          return aliasGroup.compareModel;

        }

      }

    }


    /*
     * Standard model names.
     */

    for (
      var i = 0;
      i < supportedModels.length;
      i++
    ) {

      var model =
        supportedModels[i];


      if (

        compact(normalizedTitle)

          .indexOf(
            compact(model)
          ) !== -1

      ) {

        return model;

      }

    }


    return '';

  }


  /*
   * =========================================================
   * RUN
   * =========================================================
   */

  var detectedModel =
    detectModel(productTitle);


  /*
   * =========================================================
   * MODEL FOUND
   * =========================================================
   */

  if (detectedModel) {

    button.textContent =
      'Compare ' +
      detectedModel +
      ' →';


    if (description) {

      description.textContent =
        'Compare ' +
        detectedModel +
        ' with similar Autel scanners side by side.';

    }


    var compareURL =
      '/pages/autel-scanner-comparison' +
      '?model=' +
      encodeURIComponent(
        detectedModel
      );


    if (productHandle) {

      compareURL +=
        '&handle=' +
        encodeURIComponent(
          productHandle
        );

    }


    button.href =
      compareURL;


    wrapper.setAttribute(
      'data-detected-model',
      detectedModel
    );


    wrapper.setAttribute(
      'data-compare-ready',
      'true'
    );

  }


  /*
   * =========================================================
   * MODEL NOT FOUND
   * =========================================================
   */

  else {

    button.textContent =
      'Compare Models →';


    button.href =
      '/pages/autel-scanner-comparison';


    if (description) {

      description.textContent =
        'Compare Autel scanners, features and specifications side by side.';

    }


    wrapper.removeAttribute(
      'data-detected-model'
    );


    wrapper.setAttribute(
      'data-compare-ready',
      'false'
    );

  }


  /*
   * Final cleanup after model initialization.
   */

  removeInjectedTimeText();


})();

/* =========================================
   GA4 - Product Compare CTA Tracking
========================================= */

document.addEventListener('click', function (event) {
  const button = event.target.closest('#obd-compare-button');
  if (!button) return;

  const box = document.querySelector('#obd-product-compare');

  gtag('event', 'compare_click', {
    product_name: box?.dataset.productTitle || '',
    product_handle: box?.dataset.productHandle || ''
  });
});